import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor,
  HttpHandler, HttpRequest,
  HttpHeaders, HttpErrorResponse
} from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EndPointUtils } from './end-points.utils';


/** Pass untouched request through to the next request handler. */
@Injectable()
export class WOAReqInterceptor implements HttpInterceptor {
  constructor(private endpoint: EndPointUtils) {
    // Nothing
  }
  private reqHeaders;
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    const updatedReq = req.clone({
      setHeaders: {
        'Access-Control-Allow-Origin': this.endpoint.getAllowedDomain()
      }, withCredentials: true
    });
    return next.handle(updatedReq).pipe(catchError((error, caught) => {
      // intercept the respons error and displace it to the console
      console.log(error);
      this.handleAuthError(error);
      return of(error);
    }) as any);
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      window.location.href = '/wb/Login?ed=wb&tu=' + window.location.href;
      return of(err.message);
    }
    throw err;
  }
}
